import React from "react";
import { Redirect } from "react-router";
import { z } from "zod";
import { buildLink, getPath } from "common/routing";
import { stripInvalidCharacters } from "common/utils/strings";
import { useGetOrCreateGuestPropertyQuery } from "../../generated/graphql";
import useURLParsing from "../../hooks/useURLParsing";

const parser = z.object({
  address: z.string().transform(stripInvalidCharacters).nullish(),
  lat: z.coerce.number().nullish(),
  lng: z.coerce.number().nullish(),
  parcelNumber: z.string().transform(stripInvalidCharacters).nullish(),
});

export default () => {
  const parsedParams = useURLParsing({
    routeName: "residentPropertyRedirect",
    parser,
  });

  const missingParams =
    !parsedParams ||
    !parsedParams.address ||
    parsedParams.lat === null ||
    parsedParams.lat === undefined ||
    parsedParams.lng === null ||
    parsedParams.lng === undefined;

  const { data, error, loading } = useGetOrCreateGuestPropertyQuery({
    variables: {
      address: parsedParams!.address!,
      latitude: parsedParams!.lat!,
      longitude: parsedParams!.lng!,
      parcelNumber: parsedParams!.parcelNumber,
      improveParcelCoordinates: false,
    },
    skip: missingParams,
  });

  if (loading) {
    return null;
  }

  if (missingParams) {
    return (
      <Redirect
        from={getPath("residentPropertyRedirect")}
        to={getPath("noProperty")}
      />
    );
  }

  if (error || !data?.getProperty) {
    return (
      <Redirect
        from={getPath("residentPropertyRedirect")}
        to={getPath("noProperty")}
      />
    );
  }

  return (
    <Redirect
      from={getPath("residentPropertyRedirect")}
      to={buildLink("residentProperty", {
        propertyId: data.getProperty.id,
      })}
    />
  );
};
